import { ApiError, get } from "../api/api.utils";
import { Representasjon, SessionInfo, UserInfo } from "./auth.typer";

interface AuthApi {
  getUserInfo: () => Promise<UserInfo | null>;
  getRepresentasjon: () => Promise<Representasjon>;
  getSessionInfo: () => Promise<SessionInfo>;
  refreshSession: () => Promise<SessionInfo>;
}

const authApi: AuthApi = {
  async getUserInfo(): Promise<UserInfo | null> {
    try {
      const { data } = await get<UserInfo>("/userInfo");
      return data;
    } catch (e: unknown) {
      if (e instanceof ApiError && e.status === 401) {
        return null;
      } else {
        throw e;
      }
    }
  },

  async getRepresentasjon(): Promise<Representasjon> {
    const { data } = await get<Representasjon>("/representasjon");
    return data;
  },

  async getSessionInfo(): Promise<SessionInfo> {
    const { data } = await get<SessionInfo>("/oauth2/session", { baseURL: "" });
    return data;
  },

  async refreshSession(): Promise<SessionInfo> {
    const { data } = await get<SessionInfo>("/oauth2/session/refresh", {
      baseURL: "",
      "axios-retry": {
        retries: 6,
      },
    });
    return data;
  },
};

export default authApi;
